
        import * as module0 from './controllers/paddle_controller.js';import * as module1 from './controllers/session_checker_controller.js';import * as module2 from './controllers/switcher_controller.js'
        const modules = {
            "./controllers/paddle_controller.js": module0,
            "./controllers/session_checker_controller.js": module1,
            "./controllers/switcher_controller.js": module2,
        };
        export default modules;
      